<wiz-h-divider width="100%" height="100%" gap="0" padding="5px">
  <wiz-hgroup width="350px" height="100%">
    <multi-display #mdMain width="100%" height="100%" [config]="mainConfig">
      <wiz-hgroup target="icons">
        <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-purple"
          (click)="doAct('export')">download</wiz-icon>
        <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-purple"
          (click)="doAct('import')">upload</wiz-icon>
        <wiz-icon #btnRemove [wizDisabled]="!mayDelete()" (wizClick)="askForDelete()" class="image-purple"
          [wizTooltip]="'$.common.delete.$'" (click)="askForDelete()">delete</wiz-icon>
      </wiz-hgroup>

      <wiz-hgroup target="title" [verticalAlign]="'center'" class="add-btn" gap="10" padding="0 0 10px">
        <wiz-icon #btnCreate [wizTooltip]="'$.cssrender.add.$'" tooltipPlacement="right" class="image-back-orange"
          (click)="askForAdd()" [wizDisabled]="cantCreate">add</wiz-icon>
        <wiz-label class="titleLabel" [wizLabel]="'$.cssrender.add.$'" [wizTextBehavior]="'truncate'"
          width="100%"></wiz-label>
      </wiz-hgroup>
    </multi-display>
  </wiz-hgroup>

  <!-- zone détail "vraie" -->
  <wiz-vgroup class="section-container-parent" #vgEdition wizValidationContainer width="100%" minWidth="600px"
    height="100%" gap="10" [visible]="false" [wizDisabled]="cantUpdate">
    <!-- entête d'édition -->
    <wiz-hgroup wizValidationContainer width="100%" class="section-container" padding="10px" gap="10">
      <wiz-text-input #tiCode [wizPlaceholder]="'$.common.define.$'"
        [wizValidator]="uniqueCodeValidator()" [wizLabel]="'$.common.code.$'" width="160px" [wizShowErrors]="true"
        [wizMandatory]="true" [wizMaxChars]="20">
      </wiz-text-input>
      <wiz-translation-basic #trsLabel wizValidator [wizPlaceholder]="'$.common.define.$'"
        [wizLabel]="'$.common.label.$'" width="160px" [wizShowErrors]="true" [wizMandatory]="true">
      </wiz-translation-basic>
      <wiz-translation-basic #trsDesc [wizTranslationMode]="'textarea'" [maxTranslation]="6"
        [wizLabel]="'$.common.description.$'" width="250px" height="80px"></wiz-translation-basic>
      <wiz-spacer width="100%"></wiz-spacer>

      <!-- boutons d'action -->
      <wiz-vgroup gap="0" height="100%" width="200px" horizontalAlign="center">
        <wiz-button #btnSave [wizIcon]="'arrow-right'" [wizLabel]="'$.common.save.modification.$'"
          [iconPlacement]="'right'" [wizDisabled]="disableButtons()" (wizClick)="doMerge()"></wiz-button>
        <wiz-button #btnCancel class="cancel-button" [wizIcon]="'arrow-left'"
          [wizLabel]="'$.common.cancel.modification.$'" [wizDisabled]="disableButtons()"
          (wizClick)="doCancel()"></wiz-button>
      </wiz-vgroup>
    </wiz-hgroup>

    <!-- détail d'édition -->
    <!--liste des lignes du style -->
    <wiz-hgroup wizValidationContainer width="100%" minWidth="300px" height="100%" class="section-container"
      padding="10px" gap="10" style="overflow-x: auto">
      
      <wiz-vgroup  wizValidationContainer width="300px" height="100%" horizontalAlign="end">
        <wiz-text-area #taCss [wizLabel]="'$.cssrender.css.$'" width="100%" height="100%" wizValidator [wizMandatory]="true"
          [wizMaxChars]="2000"></wiz-text-area>
        <wiz-button wizLabel="check" (wizClick)="applyCss()"></wiz-button>
      </wiz-vgroup>
     
      <wiz-hgroup>
        <wiz-vgroup>
            <wiz-text-input wizLabel="TextInput" [ngClass]="injectClass" wizValue="sample"></wiz-text-input>
            <wiz-text-area wizLabel="textArea" [ngClass]="injectClass" wizValue="sample"></wiz-text-area>
            <wiz-datefield  wizLabel="Datefield" [ngClass]="injectClass" wizNumber="19990416"></wiz-datefield>
            <wiz-dropdown wizLabel="Dropdown" [ngClass]="injectClass"></wiz-dropdown>   
            <wiz-checkbox  wizLabel="Checkbox" [ngClass]="injectClass"></wiz-checkbox>
        </wiz-vgroup>
      </wiz-hgroup>
      
      

    </wiz-hgroup>
  </wiz-vgroup>
</wiz-h-divider>